const PercentageBackgroundColorPlugin = {
    install(Vue, options) {
        Vue.prototype.$getBackgroundColorClass = function(percent) {
            return {empty: percent <= 0, 'is-danger': percent <= 20, 'is-warning': percent > 20 && percent <= 50, 'is-success': percent > 50};
        };
    }
};

export default PercentageBackgroundColorPlugin;



// WEBPACK FOOTER //
// ./src/plugins/PercentageBackgroundColorPlugin.js